import { useBrand } from "@/brand";

const RENEWABLE_IMG =
  "https://images.unsplash.com/photo-1777238418374-ba8f69591364?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwyfHx3aW5kJTIwdHVyYmluZSUyMG1vdW50YWluJTIwd2F0ZXJ8ZW58MHx8fHwxNzkwODUxMDI2fDA&ixlib=rb-4.1.0&q=85";

const RenewableSection = () => {
  const brand = useBrand();
  return (
  <section id="fornybar" className="py-24 bg-slate-50" data-testid="renewable-section">
    <div className="max-w-7xl mx-auto px-6">
      <div className="grid lg:grid-cols-2 gap-12 items-center">
        <div>
          <span className="text-xs font-bold uppercase tracking-widest text-emerald-600">
            Bærekraft &amp; Miljø
          </span>
          <h2 className="font-serif-heading text-3xl sm:text-4xl font-bold text-[#0B132B] mt-2 mb-6">
            100% Fornybar energi med opprinnelsesgaranti
          </h2>
          <p className="text-slate-600 leading-relaxed mb-6">
            Gjennom {brand.name} får din bedrift dokumentert at kraften dere
            forbruker er produsert fra rene, fornybare energikilder som vann og
            vind i Norge.
          </p>

          <div className="p-6 rounded-xl bg-emerald-50 border border-emerald-200 mb-6">
            <h4 className="text-sm font-bold text-[#064E3B] mb-2 uppercase tracking-wide">
              Faktum fra NVE (Varedeklarasjon 2020):
            </h4>
            <p className="text-sm text-slate-700 italic leading-relaxed" data-testid="nve-fact-quote">
              &quot;Strøm kjøpt uten opprinnelsesgaranti besto i 2020 av kun 11%
              fornybar energi, mens resten stammer fra fossil- og kjernekraft i
              det europeiske kraftmarkedet.&quot;
            </p>
          </div>

          <p className="text-sm text-slate-600 leading-relaxed">
            Med opprinnelsesgarantier fra {brand.name} styrker bedriften sitt
            miljøregnskap, oppfyller ESG-krav fra oppdragsgivere og bidrar
            direkte til det grønne skiftet.
          </p>
        </div>

        <div className="relative">
          <div className="w-full aspect-[4/3] rounded-2xl overflow-hidden border border-slate-200 relative flex flex-col justify-end text-white">
            <img
              src={RENEWABLE_IMG}
              alt="Vindturbin og fjellvann i Norge"
              className="absolute inset-0 w-full h-full object-cover"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent" />
            <div className="relative z-10 p-8">
              <span className="inline-block px-3 py-1 rounded bg-emerald-500/30 border border-emerald-400 text-emerald-300 text-xs font-bold uppercase mb-2">
                Dokumentert ren opprinnelse
              </span>
              <h3 className="text-xl font-bold text-white">Norsk vannkraft og vindkraft</h3>
              <p className="text-xs text-slate-300 mt-1">
                Full sporbarhet for din bedrifts bærekraftsrapport.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  );
};

export default RenewableSection;
